/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { pick } from "lodash";

import { CartItem } from "../../cart/storage/cart.types";
import { AcceptQuoteProduct } from "../storage/types";

export const mapCartItemsToAcceptQuoteProducts = (products: CartItem[]): AcceptQuoteProduct[] =>
  products.map((p) =>
    pick(p, [
      "quantity",
      "productId",
      "editedPriceExcGst",
      "lastEditedReasonCode",
      "lastEditedReasonNote",
    ])
  );
